import React, { createElement, useEffect, useRef, useState } from 'react';
import { CropperRef, Cropper, FixedCropper, ImageRestriction } from 'react-advanced-cropper';
import './editor-logo.css';
import 'react-advanced-cropper/dist/style.css'
import PreviewBg from '../../assets/images/design/preview-bg.png';
import { isMobile } from 'react-device-detect';

export const EditorLogo = (props) => {
    const propImage = props?.image;
    const { imageUpdate } = props; // دریافت تابع imageUpdate از props
    const [image, setImage] = useState(null);
    const text = props.text;
    const color = props.color;
    const font = props.font;
    const size = props.size;
    const resetImage = props.resetImage;
    const logo = props.logo;
    const resetLogo = props.resetLogo;
    const pattern = props.pattern;

    useEffect(() => {
        updatePreview();
    }, [text, color, size, font, logo, pattern]);

    useEffect(() => {
        onPatternChanged();
    }, [pattern]);


    const updatePreview = () => {
        let element = document.createElement('div');
        let img = document.createElement('img');
        const emptyDiv = document.createElement('div');
        const textSpan = document.createElement('span');

        textSpan.textContent = text ?? '';

        img.height = '70';
        img.width = '70';
        img.style.height = '70px';
        img.style.width = '70px';
        img.style.aspectRatio = '1/1';
        img.style.overflow = 'hidden';

        img.style.marginLeft = '10px';
        emptyDiv.textContent = ' ';
        emptyDiv.style.height = '70px';
        emptyDiv.style.width = '70px';

        if (logo) {
            img.src = (URL.createObjectURL(logo));
        }
        else {
            img.style.opacity = '0'
        }

        // element.appendChild(emptyDiv);
        element.appendChild(textSpan);
        element.appendChild(img);
        console.log('...', font)
        element.classList.add('img-preview-logo');
        element.style.setProperty('color', color, 'important')
        element.style.setProperty('font-family', font, 'important')
        element.style.setProperty('font-size', size + 'px', 'important')
        element.style.setProperty('background-image', `url(${PreviewBg})`);
        console.log(element.style)
        let target = document.getElementsByClassName('advanced-cropper-rectangle-stencil__preview')?.item(0);
        if (!!target) {
            target.innerHTML = '';
            target.appendChild(element)
        }
        updateResult();
    };

    // Pattern changed event
    const onPatternChanged = () => {
        setTimeout(() => {
            document.getElementsByClassName('advanced-cropper-stencil-overlay').item(0)?.children[0].
                style.setProperty('background-image', `url(${pattern.primaryIcon})`, 'important')
        }, 1);
    };

    const updateResult = async (e = null) => {
        const cropperCanvas = e?.getCanvas() || cropperRef.current.getCanvas();
        if (!cropperCanvas) {
            return;
        }

        let cropperElement = document.getElementsByClassName('advanced-cropper-rectangle-stencil').item(0);
        const finalWidth = cropperElement.offsetWidth;
        const finalHeight = cropperElement.offsetHeight - 7.15; // 7.15 is the cancled transform in css

        const scaleFactor = 2; // مقیاس رزولوشن
        const canvas = document.getElementById('result-canvas');
        canvas.width = finalWidth * scaleFactor; // تنظیم عرض Canvas با درنظر گرفتن مقیاس
        canvas.height = finalHeight * scaleFactor; // تنظیم ارتفاع Canvas با درنظر گرفتن مقیاس
        const context = canvas.getContext('2d');

        // تنظیم مقیاس Canvas برای وضوح بالاتر
        context.scale(scaleFactor, scaleFactor);

        // رسم تصویر اصلی
        const mainImage = new Image();
        mainImage.src = cropperCanvas.toDataURL('image/png');
        await new Promise((resolve) => {
            mainImage.onload = () => {
                context.drawImage(mainImage, 0, 0, finalWidth, finalHeight);
                resolve();
            };
        });

        // رسم الگوی تکرارشونده (Pattern)
        if (pattern?.icon) {
            const patternImage = new Image();
            patternImage.src = pattern.primaryIcon;
            await new Promise((resolve) => {
                patternImage.onload = () => {
                    context.drawImage(patternImage, 0, 0, finalWidth, finalHeight);
                    resolve();
                };
            });
        }

        // رسم تصویر پس‌زمینه
        const PreviewImg = new Image();
        PreviewImg.src = PreviewBg;
        await new Promise((resolve) => {
            PreviewImg.onload = () => {
                context.drawImage(PreviewImg, 0, 0, finalWidth, finalHeight);
                resolve();
            };
        });

        // رسم متن
        if (text) {

                  // پیدا کردن متن از کلاس img-preview
                  const imgPreviewElement = document.querySelector('.img-preview-logo');
                  const previewText = imgPreviewElement ? imgPreviewElement.innerText : 'متن پیش‌فرض';
              // تعیین رنگ متن و بوردر
                  const isWhiteText = color.toLowerCase() === "#ffffff" || color.toLowerCase() === "white";
                  // اضافه کردن stroke و paint-order به عنصر img-preview
                  if (imgPreviewElement) {
                      imgPreviewElement.style.webkitTextStroke = `1.5px ${isWhiteText ? "black" : "white"}`; // استروک متن
                      imgPreviewElement.style.paintOrder = 'stroke fill'; // ترتیب رسم استروک و متن
                      imgPreviewElement.style.color = color; // رنگ متن
                  }
            const borderColor = isWhiteText ? "black" : "white";

            context.font = `${size }px ${font}`; // متن با اندازه متناسب با مقیاس
            context.fillStyle = color;
            context.textAlign = 'center';
            context.textBaseline = 'bottom';

            const isMobile = window.innerWidth <= 768; // اگر عرض صفحه کمتر یا مساوی 768 باشد، موبایل در نظر گرفته می‌شود

            // رسم بوردر برای متن
            context.lineWidth = 1.5 * scaleFactor; // ضخامت بوردر
            context.strokeStyle = borderColor; // رنگ بوردر
            context.strokeText(previewText,finalWidth / 2, finalHeight - (isMobile ? 40 : 60)); // رسم بوردر متن


            context.fillText(text ? text : '', finalWidth / 2, finalHeight - (isMobile ? 40 : 60));
        }

        // رسم لوگو
        if (logo) {
            const logoImage = new Image();
            logoImage.src = URL.createObjectURL(logo);
            const isMobile = window.innerWidth <= 768; // اگر عرض صفحه کمتر یا مساوی 768 باشد، موبایل در نظر گرفته می‌شود
            await new Promise((resolve) => {
                logoImage.onload = () => {

                    const logoSize =isMobile ? 40 : 70; // اندازه لوگو
                    context.drawImage(
                        logoImage,
                        isMobile ?  25 : 30,
                        isMobile ? 40 : 60,
                        logoSize ,
                        logoSize 
                    ); // لوگو با مقیاس تنظیم شده
                    resolve();
                };
            });
        }

        // به‌روزرسانی تصویر نهایی
        const finalImage = canvas.toDataURL('image/png');
        setResultImage(finalImage.replace(/^data:image\/png;base64,/, ''));
        if (imageUpdate) {
            imageUpdate(finalImage.replace(/^data:image\/png;base64,/, '')); // ارسال تصویر نهایی
        }
    };

    const [resultImage, setResultImage] = useState(null);


    // Image Change event
    useEffect(() => {
        let image = propImage;
        if (!!image && typeof image === 'object') {
            const blob = URL.createObjectURL(image);
            setImage({
                src: blob,
                type: image.type
            });
        }
        else if (!!image && typeof image === 'string') {
            setImage({
                src: image,
            });
        }
        setTimeout(() => {
            updatePreview();
            onPatternChanged();
            setTimeout(() => {
                if (isMobile) {
                    zoom(1.1);
                }
                else {
                    zoom(1.01);
                }
            }, 10);
        }, 600);
    }, [propImage]);


    useEffect(() => {
        return () => {
            if (image && image.src) {
                URL.revokeObjectURL(image.src);
            }
        };
    }, [image]);



    // Cropper properties
    const cropperRef = useRef(null);
    const zoom = (scale) => {
        if (cropperRef.current) {
            cropperRef.current.zoomImage(scale); // zoom-in 2x
        }
    };
    const rotate = (angle) => {
        if (cropperRef.current) {
            cropperRef.current.rotateImage(angle);
        }
    };
    const move = (x = 0, y = 0) => {
        if (cropperRef.current && (x || y)) {
            cropperRef.current.moveImage(x, y); // move x = 50, y = 100
        }
    };

    return (
        <>
            <div className="flex flex-col  gap-3">
                <img className='help-img' src={require('../../assets/images/design/help.svg').default} width={171} alt="" />

                <FixedCropper
                    stencilProps={{
                        handlers: false,
                        lines: false,
                        movable: false,
                        resizable: false,
                    }}
                    stencilSize={{
                        width: 500,
                        height: 300
                    }}
                    ref={cropperRef}
                    imageRestriction={ImageRestriction.stencil}
                    onInteractionEnd={updateResult}
                    onTransitionsEnd={updateResult}
                    src={
                        image && image.src
                    }
                />
                <div className="flex gap-3 justify-center mt-3 [&_.item]:hover:scale-[105%] [&_.item]:animation">
                    <div className='flex gap-1 '>
                        <button className='item' onClick={() => zoom(1.1)}>
                            <img src={require('../../assets/icons/editor/zoom-in.svg').default} alt="" />
                        </button>
                        <button className='item' onClick={() => zoom(0.9)}>
                            <img src={require('../../assets/icons/editor/zoom-out.svg').default} alt="" />
                        </button>
                    </div>
                    <div className='flex gap-1'>
                        <button className='item' onClick={() => rotate(-90)}>
                            <img src={require('../../assets/icons/editor/rotate-left.svg').default} alt="" />
                        </button>
                        <button className='item' onClick={() => rotate(90)}>
                            <img src={require('../../assets/icons/editor/rotate-right.svg').default} alt="" />
                        </button>
                    </div>
                    <div className='flex gap-1'>
                        <button className='item' onClick={() => move(-30, 0)}>
                            <img src={require('../../assets/icons/editor/move-right.svg').default} alt="" />
                        </button>
                        <button className='item' onClick={() => move(30, 0)}>
                            <img src={require('../../assets/icons/editor/move-left.svg').default} alt="" />
                        </button>
                    </div>
                    <div className='flex gap-1'>
                        <button className='item' onClick={() => move(0, -30)}>
                            <img src={require('../../assets/icons/editor/move-down.svg').default} alt="" />
                        </button>
                        <button className='item' onClick={() => move(0, 30)}>
                            <img src={require('../../assets/icons/editor/move-up.svg').default} alt="" />
                        </button>
                        <button className="item" onClick={resetImage}>
                            <img src={require('../../assets/icons/editor/close.svg').default} alt="" />

                        </button>
                    </div>

                </div>

                <div className="mt-5" style={{ display: 'none' }}>
                    {/* <img src={resultImage} alt="" /> */}
                    <canvas className='max-w-[100%]' id='result-canvas'></canvas>

                    {/* Final Image preview (just to debug, comment in product mode) */}
                    {/* <img src={textedImage} alt="" /> */}
                </div>
                <img id='logo-canvas' src={logo ? URL.createObjectURL(logo) : ''} className='d-none' />
                <div id="test"></div>
            </div>
        </>
    );
};

export default EditorLogo;
